/* SMS über das Geschäftshandy (06.10.2026): Das CRM verschickt nichts selbst. Ein Link öffnet die Nachrichten-App
   des Geräts mit Nummer und Text, ein Mensch tippt auf Senden.

   Zwei Schreibweisen, weil Apple und der Rest der Welt den Text unterschiedlich anhängen:
   - iPhone, iPad, Mac:  sms:+4917…&body=Text
   - Android und andere: sms:+4917…?body=Text   (RFC 5724)
   iPadOS meldet sich als „Macintosh" — auch dafür passt die Apple-Schreibweise. */

export function istApple(nav = (typeof navigator !== 'undefined' ? navigator : null)) {
  if (!nav) return false;
  return /iPhone|iPad|iPod|Macintosh|Mac OS X/.test(nav.userAgent || '') || /^(Mac|iP)/.test(nav.platform || '');
}

/** Link für die Nachrichten-App, oder null, wenn die Nummer keine internationale Nummer ist (+49…). */
export function smsLink(nummer, text, { apple = istApple() } = {}) {
  const ziel = String(nummer || '').replace(/[\s()/-]/g, '');
  if (!/^\+\d{8,15}$/.test(ziel)) return null;
  const body = encodeURIComponent(String(text || '').trim());
  if (!body) return `sms:${ziel}`;
  return apple ? `sms:${ziel}&body=${body}` : `sms:${ziel}?body=${body}`;
}

// GSM-7: Was hier nicht drinsteht, macht aus der SMS eine Unicode-SMS mit 70 statt 160 Zeichen je Teil.
// Dieselbe Tabelle wie backend/sms_handy/kern.py — die Tests prüfen beide mit denselben Beispielen.
const GSM7 = new Set('@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà');
const GSM7_DOPPELT = new Set('^{}\\[~]|€');

/** Typografische Zeichen auf die schlichte Form bringen — dieselbe Tabelle wie backend/sms_handy/kern.py GSM_ERSATZ. */
const ERSATZ = { '–': '-', '—': '-', '‐': '-', '‑': '-', '„': '"', '“': '"', '”': '"', '‚': "'", '‘': "'", '’': "'", '…': '...', '\u00a0': ' ', '\u202f': ' ' };
export function gsmText(text) {
  return String(text || '').replace(/[–—‐‑„“”‚‘’…\u00a0\u202f]/g, z => ERSATZ[z] || z);
}

/** { zeichen, teile, unicode } — wie viele SMS aus dem Text werden. */
export function smsLaenge(text) {
  const t = String(text || '');
  const zeichenListe = Array.from(t);
  const unicode = zeichenListe.some(z => !GSM7.has(z) && !GSM7_DOPPELT.has(z));
  if (unicode) {
    const zeichen = t.length;                       // UTF-16-Einheiten: Emoji zählen doppelt
    return { zeichen, teile: zeichen === 0 ? 0 : (zeichen <= 70 ? 1 : Math.ceil(zeichen / 67)), unicode };
  }
  const zeichen = zeichenListe.reduce((n, z) => n + (GSM7_DOPPELT.has(z) ? 2 : 1), 0);
  return { zeichen, teile: zeichen === 0 ? 0 : (zeichen <= 160 ? 1 : Math.ceil(zeichen / 153)), unicode };
}
